import { render, staticRenderFns } from "./InformationOrganization.vue?vue&type=template&id=4cb395ea&"
import script from "./InformationOrganization.vue?vue&type=script&lang=js&"
export * from "./InformationOrganization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports